import CourseBanner from './thervumitra/learning/CourseBanner';
import CourseSideNav from './thervumitra/learning/CourseSideNav';
import { useCourseMetadata } from './courseMetadata';

// The learning MFE's course layout on the instructor dashboard: the course
// banner in the header's course bar (customApp.tsx) and the course menu on
// the left of the page (patch-instructor-dashboard.js wraps PageWrapper).
export const InstructorCourseBanner = () => {
  const meta = useCourseMetadata();
  return meta ? <CourseBanner courseId={meta.courseId} title={meta.title} /> : null;
};

export const InstructorSideNav = () => {
  const meta = useCourseMetadata();
  return meta ? <CourseSideNav tabs={meta.tabs} activeTabSlug="instructor" /> : <nav className="bm-course-nav" aria-hidden="true" />;
};
